import { render, staticRenderFns } from "./ReviewTabAwaitingYou.vue?vue&type=template&id=58c5b808&"
import script from "./ReviewTabAwaitingYou.vue?vue&type=script&lang=js&"
export * from "./ReviewTabAwaitingYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports